import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env'
import { ProductVtexResponse } from '@models'
import { firstValueFrom } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ProductVtexService {
  constructor(private http: HttpClient) {}

  async getProduct(model: string, fetchInfographic: boolean = false): Promise<ProductVtexResponse> {
    let url = `${environment.api.baseUrl}/api-vtex/v1/full-products/${model}`

    if (fetchInfographic) url += '?fetchInfographic=true'

    const response = await firstValueFrom(this.http.get<ProductVtexResponse>(url))
    return response
  }
}
